import { CondimentForCalculationInterface } from "../../../entities/Calculation";
import { MixtureChooseEnum } from "../../../entities/Mixture";

export const calculateMixCondimentsProperties = (
  condiments: CondimentForCalculationInterface[],
  mixtureOption: MixtureChooseEnum,
) => {
  if (mixtureOption === MixtureChooseEnum.GRAMS) {
    return condiments.map(({ percentage, parts, ...rest }) => ({ ...rest }));
  }

  if (mixtureOption === MixtureChooseEnum.PERCENTAGE) {
    return condiments.map(({ grams, parts, ...rest }) => ({ ...rest }));
  }

  if (mixtureOption === MixtureChooseEnum.PARTS) {
    return condiments.map(({ grams, percentage, ...rest }) => ({ ...rest }));
  }

  return condiments;
};
